"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, SpaceBetween, TextBody, TextBodySkeleton } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { getSwapProviderName } from "../../../utils";
import { SwapDetailsProviderItemFragment } from "./SwapDetailsProviderItem.fragment";
export const SwapDetailsProviderItem = t0 => {
  const $ = _c(15);
  const {
    swapRoute: swapRouteKey
  } = t0;
  const swapRoute = readFragment(SwapDetailsProviderItemFragment, swapRouteKey);
  const t = useTranslations("wallet.SwapDetailsProviderItem");
  if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsProviderItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const T0 = SpaceBetween;
  let t1;
  if ($[1] !== t) {
    t1 = t("route");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const T1 = FlexCenter;
  const T2 = TextBody;
  const t3 = "font-mono";
  const t4 = "text-secondary";
  const t5 = getSwapProviderName(swapRoute.swapProvider);
  let t6;
  if ($[5] !== T2 || $[6] !== t5) {
    t6 = <T2 className={t3} color={t4}>{t5}</T2>;
    $[5] = T2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== T1 || $[9] !== t6) {
    t7 = <T1>{t6}</T1>;
    $[8] = T1;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== T0 || $[12] !== t2 || $[13] !== t7) {
    t8 = <T0>{t2}{t7}</T0>;
    $[11] = T0;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
const SwapDetailsProviderItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsProviderItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("route");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBodySkeleton className="w-[80px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};